// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"30394df8","740":"1777cf35","788":"811f88f6"}[chunkId] + ".chunk.css";
};